import { Box } from '@mui/material';
import ProjectInfo from '../shared-components/ProjectInfo';
import CbDataMonitoring from './CbDataMonitoring';
import CbDataTables from './CbDataTables';

/**
 * Wraps the Conservation Burns components that render under 'Project Info' || 'Data Monitoring' || 'Data Tables' || 'Reports'
 * @param {Object} props 
 * @param {'Flame Cap Kiln' | 'Conservation Burns'} props.burnType 
 * @param {string | null} props.selectedCategory 'Project Info' || 'Data Monitoring' || 'Data Tables' || 'Reports'
 * @returns {JSX.Element} Associated component for the selected button
 */
export default function CbDataSelection({ selectedCategory, burnType }) {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            {
                selectedCategory === 'Project Info' &&
                <ProjectInfo burnType={burnType} />
            }
            {
                selectedCategory === 'Data Monitoring' &&
                <CbDataMonitoring />
            }
            {
                selectedCategory === 'Data Tables' &&
                <CbDataTables />
            }
        </Box>
    )
}
